// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"_3szkGIm-aVQdVATosCbyxj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Resources/components/ResourcesPlaceholder.mod.css
// module id = 1640
// module chunks = 0